export default "__VITE_ASSET__BJti50hf__"